import React, { useEffect, useState } from "react";
import { DragOverlay, Modifiers, useDndContext } from "@dnd-kit/core";
import { useRegisterDragAndDropScopeContext } from "utilities/contexts/shared-drag-and-drop/register-drag-and-drop-scope-context";
import { useSharedDragAndDropContext } from "utilities/contexts/shared-drag-and-drop/shared-drag-and-drop-context";

export const ShareDragAndDropOverlay: React.FC = (): JSX.Element => {
    const { active } = useDndContext();
    const { DraggableContent, isDragging } = useSharedDragAndDropContext();
    const { getScopeConfigurationByDraggable } =
        useRegisterDragAndDropScopeContext();
    const [modifiers, setModifiers] = useState<Modifiers>([]);

    useEffect(() => {
        if (active == null) {
            setModifiers([]);
            return;
        }

        const configuration = getScopeConfigurationByDraggable(active);

        setModifiers(configuration?.overlayModifiers ?? []);
    }, [active, getScopeConfigurationByDraggable]);

    return (
        <DragOverlay modifiers={modifiers}>
            {isDragging && DraggableContent && <DraggableContent />}
        </DragOverlay>
    );
};
